import { validateGonkaAddress } from '@gonka-wallet/crypto';
import { GONKA_CHAIN } from './config.js';
import { CryptoError } from './errors.js';
const POSITIVE_INTEGER = /^[1-9][0-9]*$/;
export function buildSendTx(input) {
    if (!validateGonkaAddress(input.from)) {
        throw new CryptoError('INVALID_ADDRESS', 'errors.tx.invalidSender');
    }
    if (!validateGonkaAddress(input.to)) {
        throw new CryptoError('INVALID_ADDRESS', 'errors.tx.invalidRecipient');
    }
    if (!POSITIVE_INTEGER.test(input.amountNgonka)) {
        throw new CryptoError('AMOUNT_TOO_SMALL', 'errors.tx.amountTooSmall');
    }
    const message = {
        typeUrl: '/cosmos.bank.v1beta1.MsgSend',
        value: {
            fromAddress: input.from,
            toAddress: input.to,
            amount: [{ denom: GONKA_CHAIN.denom.base, amount: input.amountNgonka }],
        },
    };
    const fee = {
        amount: [],
        gas: '200000',
    };
    return {
        messages: [message],
        fee,
        memo: input.memo ?? '',
    };
}
//# sourceMappingURL=txBuilder.js.map